// Importing aggregated styles
import './styles/main.scss';

// Importing external angular
import angular from 'angular';

// Importing the datacenter app
import mainModule from './js/main';

angular.element(document).ready(() => {
  // IF IE11 timeout... to catch painting issues
  if (window.navigator.userAgent.indexOf('Trident/7.0') >= 0) {
    window.setTimeout(bootStrap, 100);
  } else {
    bootStrap();
  }
});

function bootStrap() {
  angular.bootstrap(
    document.querySelector('[kff-datacenter]'),
    [mainModule.name],
    { strictDi: true }
  );
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./datacenter.js
 **/